/* © 2014 - Copyright of Aetonix Systems Inc - All Rights Reserved. Patent pending.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Aetonix, June 19, 2014
 * For information or permission request, email info@aetonixsystems.com
 */

var Model = require("../types/Model.js");
// eslint-disable-next-line node/no-missing-require
var Platform = require("react-native").Platform;

module.exports = Model({
	name: "updatefetcher",
	init: init,
	listeners: listeners,
	check_version: check_version,
});

function init() {
	this.push(false);
	this.check_version();
}

function listeners(){
	return {
		"connectivity:online": check_version
	};
}

function check_version(){
	if(Platform.OS === "web") return;
	this.api.version.latest("mobile", Platform.OS)
		.then(update_version.bind(this));
}

function update_version(latestVersion){
	if(this.config.version !== latestVersion.version) this.push(true);
}